<template>
    <div id="roasProductUploadCsvContainer">
        <div class="header">
            <h3>ECモール広告CSVアップロード</h3>
            <a class="btn close" @click="$emit('modalClosed')"></a>
        </div>
        <label for="file">
            <div class="uploadArea" :class="[{ 'drag': isDrag }]" @dragover.prevent="onDrag($event, true)"
                @dragleave.prevent="onDrag($event, false)" @drop.prevent="onDrop" ref="uploadArea">
                <div class="info" v-if="files.length == 0">
                    <div>ファイルをドラッグするか、クリックして選択してください。</div>
                    <div>複数可</div>
                </div>
                <ul v-if="files.length">
                    <li v-for="file in files" :key="file.id" @click.prevent>
                        <div class="fileIcon">
                            <Icon title="csv">file-document-outline</Icon>
                        </div>
                        <div class="fileName" :title="file.name">{{ file.name }}</div>
                        <div class="fileStatus" v-if="file.error">
                            <button class="btn normal small" v-if="file.error" @click="fileErrors = file.error">
                                <Icon title="エラー" color="error">alert-outline</Icon>
                            </button>
                        </div>
                        <div class="fileStatus" v-else-if="file.progress > 0">{{ file.progress }}%</div>
                        <div class="fileStatus" v-else-if="file.success">
                            <Icon title="成功" color="success">check-circle-outline</Icon>
                        </div>
                        <div class="fileStatus" v-else-if="file.active">
                            <vue-loaders name="ball-pulse" color="#02AD90" scale="0.5" />
                        </div>
                        <div class="fileStatus" v-else></div>
                    </li>
                </ul>
            </div>
        </label>
        <div class="actions">
            <file-upload :custom-action="action" extensions="csv" accept="text/csv" :multiple="true"
                :drop="$refs.uploadArea" :drop-directory="true" v-model="files" @input-filter="inputFilter"
                ref="upload">
            </file-upload>

            <button type="button" class="btn btn-success" @click.prevent="$refs.upload.active = true">
                アップロード
            </button>
            <button type="button" class="btn btn-danger" @click.prevent="$refs.upload.clear()">
                リセット
            </button>
        </div>


        <modal class="uploadCsvError" name="uploadCsvError" :draggable="false" :resizable="false" :scrollable="true"
            width="800" height="auto" @closed="fileErrors = null">
            <div class="header">
                <h3>CSVエラー</h3>
                <a class="btn close" @click="$modal.hide('uploadCsvError')"></a>
            </div>
            <div class="content">
                <div v-if="defaultFileErrorMessage">
                    {{ defaultFileErrorMessage }}
                </div>
                <ul v-else>
                    <li v-for="(fileError, index) in fileErrors" :key="index">
                        <div class="errorRowIndex">
                            <template v-if="fileError.row_index != 0">
                                {{ fileError.row_index }}行目
                            </template>
                        </div>
                        <ul>
                            <li v-for="(error, index) in fileError.error" :key="index">
                                {{ error }}
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </modal>


        <modal class="uploadCsvError" name="uploadCsvCheck" :draggable="false" :resizable="false" :scrollable="false"
            :clickToClose="false" width="500" height="auto">
            <div class="header">
                <h3>取込済みの日付のデータが含まれています。<br>すべて更新しますか？</h3>
            </div>
            <div class="modalBtn">
                <button type="button" class="btn btn-success" @click="onConfirmClick">はい</button>
                <button type="button" class="btn btn-danger" @click="onCancelClick">いいえ</button>
            </div>
        </modal>
    </div>
</template>

<script>
import FileUpload from 'vue-upload-component'

export default {
    components: {
        FileUpload,
    },
    data() {
        return {
            isDrag: false,
            files: [],
            fileErrors: null,
            targetFile: null,
        }
    },
    mounted: function () {
    },
    methods: {
        action: async function (file) {
            this.targetFile = file;

            const formData = new FormData();
            formData.append('file', file.file, file.file.filename || file.name);

            await this.axios.post('/api/mallAdCosts/csv', formData)
                .then(async (response) => {
                    //バリデーションエラー
                    if (response.data.status == "error") {
                        // レスポンスからバリデーションエラーメッセージを取得して設定
                        file.error = response.data.data || null;
                        this.$toast.error('CSVアップロードエラー', { timeout: 5000 });
                    }

                    //エラーなし・取込済み日付あり
                    else if (response.data.status == "check") {
                        //確認モーダル表示
                        //await → 処理が終わるまで待つ
                        await this.confirmUpdatePromise();
                    }

                    //エラーなし・新規日付のみ
                    else {
                        //更新処理実行
                        this.confirmUpdate();
                    }
                })
                .catch(error => {
                    file.error = error.response.data.errors.file || null;
                    this.$toast.error('CSVアップロードエラー', { timeout: 5000 });
                });
        },

        //確認モーダル表示
        confirmUpdatePromise() {
            return new Promise((resolve, reject) => {
                // resolveとrejectをグローバルまたはコンポーネントレベルの変数に保持
                this.resolveUpdate = resolve;
                this.rejectUpdate = reject;

                //表示
                this.$modal.show('uploadCsvCheck');
            });
        },

        //確認モーダルで「はい」をクリックしたとき
        async onConfirmClick() {
            //更新処理実行
            await this.confirmUpdate();

            //モーダル閉じる
            this.$modal.hide('uploadCsvCheck');
            this.resolveUpdate();
        },

        //確認モーダルで「いいえ」をクリックしたとき
        async onCancelClick() {
            //更新処理実行
            await this.confirmUpdateNo();

            //モーダル閉じる
            this.$modal.hide('uploadCsvCheck');
            this.resolveUpdate();
        },

        //更新処理（取込済み日付上書きモード）
        confirmUpdate: async function () {
            this.$modal.hide('uploadCsvCheck');

            const formData = new FormData();
            formData.append('file', this.targetFile.file, this.targetFile.file.filename || this.targetFile.name);

            await this.axios.post('/api/mallAdCosts/confirmCsv', formData)
                .then(response => {
                    if (response.data != "") {
                        this.targetFile.error = response.data.data || null;
                        this.$toast.error('CSVアップロードエラー', { timeout: 5000 });
                    }
                    else {
                        this.$emit('uploaded');
                    }
                })
                .catch(error => {
                    this.targetFile.error = error.response.data.errors.file || null;
                    this.$toast.error('CSVアップロードエラー', { timeout: 5000 });
                });
        },

        //更新処理（取込済み日付無視モード）
        confirmUpdateNo: async function () {
            this.$modal.hide('uploadCsvCheck');

            const formData = new FormData();
            formData.append('file', this.targetFile.file, this.targetFile.file.filename || this.targetFile.name);

            await this.axios.post('/api/mallAdCosts/confirmCsvNo', formData)
                .then(response => {
                    if (response.data != "") {
                        this.targetFile.error = response.data.data || null;
                        this.$toast.error('CSVアップロードエラー', { timeout: 5000 });
                    }
                    else {
                        this.$emit('uploaded');
                    }
                })
                .catch(error => {
                    this.targetFile.error = error.response.data.errors.file || null;
                    this.$toast.error('CSVアップロードエラー', { timeout: 5000 })
                });
        },

        //ファイルアップロード関連処理
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                if (!/\.(csv)$/i.test(newFile.name)) {
                    return prevent()
                }
            }
        },
        onDrag: function (event, status) {
            if (status && event.dataTransfer.types == 'text/plain') {
                // ファイルではなく、html要素をドラッグしてきた時は処理を中止
                return false
            }
            this.isDrag = status;
        },
        onDrop: function () {
            this.isDrag = false;
        },
    },
    watch: {
        fileErrors: function (v) {
            if (v) {
                this.$modal.show('uploadCsvError')
            }
        },
    },
    computed: {
        defaultFileErrorMessage: function () {
            if (Array.isArray(this.fileErrors)) {
                return null
            }
            // FileUpload defaule error
            //   size, extension, timeout, abort, network, server, denied
            const errors = {
                size: 'サイズオーバー',
                extension: '拡張子が違います',
            }
            return errors[this.fileErrors] ?? `${this.fileErrors}エラー`
        },
    },
}
</script>

<style scoped lang="sass">
#roasProductUploadCsvContainer
    padding: 15px
    height: 100%
    width: 100%
    display: inline-grid
    grid-template-columns: 1fr
    grid-template-rows: 57px 1fr 50px
    .header
        overflow: hidden
        padding: 5px
        h3
            display: block
            float: left
            padding: 10px
            font-size: 1.7rem
        .btn.close
            float: right
    .uploadArea
        position: relative
        padding: 1em
        background: $whiteColor
        border-style: dashed
        border-width: 3px
        border-color: $grayColor
        border-radius: 1em
        height: 300px
        cursor: pointer
        overflow: scroll
        &.drag
            background: #e0f2f1
            border-color: $mainColor
        .info
            position: absolute
            top: 50px
            width: 100%
            text-align: center
            font-size: 1.5em
            color: #666
            div
                margin-bottom: 1em
        ul
            li
                align-items: center
                margin: 2px
                padding: 5px
                width: 100%
                height: 50px
                background: #f5f5f5
                border: 1px solid $mainColor
                display: inline-grid
                grid-template-columns: 50px 1fr 100px
                grid-template-rows: 1fr
                cursor: default
                div
                    font-size: 1.5em
                    white-space: nowrap
                    overflow: hidden
                    text-overflow: ellipsis
                    vertical-align: middle
                    &.fileIcon
                        text-align: center
                    &.fileName
                        line-height: 1.5em
                    &.fileStatus
                        text-align: center
    .actions
        display: flex
        flex-direction: row
        gap: 20px
        padding-top: 10px
        justify-content: center
        .file-uploads
            display: none
    .btn-danger
        background-color: #ccc
        border: 1px solid #ccc
        color: #000
.uploadCsvError
    .header
        h4
            float: left
            font-size: 1.7rem
        .close
            float: right
    .content
        padding: 1em
        font-size: 1.5em
        > div
            margin: 2px
            padding: 10px 20px
            width: 100%
            background: #f5f5f5
            border: 1px solid $grayColor
        > ul > li
            align-items: start
            margin: 2px
            padding: 10px 5px
            width: 100%
            background: #f5f5f5
            border: 1px solid $grayColor
            display: inline-grid
            grid-template-columns: 150px 1fr
            grid-template-rows: 1fr
            > div
                padding-left: 10px
                padding-right: 30px
            > ul > li
                margin-top: 15px
                &:first-of-type
                    margin-top: 0
    .modalBtn
        display: flex
        flex-direction: row
        gap: 20px
        margin: 20px 0
        justify-content: center
</style>
